
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { routerNames } from "@/common/js/const";
import { setToken, getToken } from "@/common/js/common";
import conf from "./../../config/base.js";
import axios from "axios";
import qs from "qs";
import regexpValid from "@/common/js/regexp.js";
import Clipboard from "clipboard";
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: routerNames.OrderInvoicesOwtDetail,
directives: {
TransferDom
},
components: {
Group,
Cell,
Divider,
CellBox,
XHeader,
Icon,
Box,
XButton,
CellFormPreview,
Actionsheet,
XDialog,
Previewer
},
data() {
return {
imageSlide1: [
{
src: "",
msrc: "",
alt: "",
title: "",


pid: "image-one"
}
],
appKey: "",
showSellerDetail: false,
showBuyerDetail: false,
showGoodsDetail: false,
showElectricOpt: false,
showEmail: false,
showWxCard: false,

invoiceInfo: {
invoiceId: "",
invoiceCode: "",
invoiceNo: "",
price: "",
groupFlag: "",
pdfAddr: "", //pdf地址
typeName: "增值税电子普通发票",
totalTaxAmount: "",
thumbnail: "", //图片地址
buyerEmail: "",
buyerName: "",
buyerFormDetail: [
{
label: this.$t("名称"),
value: ""
},
{
label: this.$t("税号"),
value: ""
},
{
label: this.$t("开户行"),
value: ""
},
{
label: this.$t("银行账号"),
value: ""
},
{
label: this.$t("电话"),
value: ""
},
{
label: this.$t("地址"),
value: ""
}
],
sellerName: "",
sellerFormDetail: [
{
label: this.$t("名称"),
value: ""
},
{
label: this.$t("税号"),
value: ""
},

{
label: this.$t("开户行"),
value: ""
},
{
label: this.$t("银行账号"),
value: ""
},
{
label: this.$t("电话"),
value: ""
},
{
label: this.$t("地址"),
value: ""
}
],
invoiceDetailInfo: [
{
label: this.$t("发票日期"),
value: ""
},
{
label: this.$t("发票号码"),
value: ""
},
{
label: this.$t("发票代码"),
value: ""
},
{
label: "",
value:
"<span style='color:#ff9900;'>" +
this.$t("该发票已通过国税局验真") +
"</span>"
}
]
}
};
},
created() {},
activated() {
var $self = this;
$self.getInvoiceDetail();
document.getElementById("app_body").style["background-color"] = "#2b88d8";
},
beforeRouteLeave(to, from, next) {
document.getElementById("app_body").style["background-color"] = "#fbf9fe";
next();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {

getInvoiceDetail() {
var $self = this;
$self.appKey = $self.$route.query.appKey;
var params = {
appKey: $self.appKey,
id: $self.$route.params.id,
period: $self.$route.query.period
};
$self.$webapi.getInvoiceDetail(params).then(res => {
$self.$clog(res.data);
if (res.data.header.code == 0) {
const invoice = res.data.body.responseData;

$self.invoiceInfo.invoiceNo = invoice.invoiceNo;
$self.invoiceInfo.invoiceCode = invoice.invoiceCode;
$self.invoiceInfo.price = invoice.amountWithTax;


if (invoice.invoiceType == "ce") {
$self.invoiceInfo.typeName = "增值税电子普通发票";
$self.showElectricOpt = true;
} else if (invoice.invoiceType == "c") {
$self.invoiceInfo.typeName = "增值税普通发票";
$self.showElectricOpt = false;
} else if (invoice.invoiceType == "s") {
$self.invoiceInfo.typeName = "增值税专用发票";
$self.showElectricOpt = false;
}
$self.imageSlide1[0].src = invoice.pvs;
$self.imageSlide1[0].msrc = invoice.pvs;
$self.invoiceInfo.totalTaxAmount = "￥" + invoice.amountWithTax;
$self.invoiceInfo.thumbnail = invoice.pvs;
$self.invoiceInfo.pdfAddr = invoice.pdfUrl;
$self.invoiceInfo.buyerName = invoice.purchaserName;

var clipboard = new Clipboard(".copy-btn", {
text: function() {
return invoice.pdfUrl;
}
});
clipboard.on("success", e => {
console.log(e);
$self.$vux.alert.show({
title: $self.$t("提示"),
content: $self.$t("PDF下载链接已复制到粘贴板"),
onShow() {
console.log("Plugin: I'm showing");
},
onHide() {
console.log("Plugin: I'm hiding now");
}
});
});
clipboard.on("error", e => {
console.log(e);
$self.$vux.alert.show({
title: this.$t("长按下面文字复制"),
content: $self.invoiceInfo.pdfAddr,
onShow() {

},
onHide() {

}
});
});
$self.invoiceInfo.buyerFormDetail = [
{
label: this.$t("名称"),
value: invoice.purchaserName
},
{
label: this.$t("税号"),
value: invoice.purchaserTaxNo
},
{
label: this.$t("开户行"),
value: invoice.purchaserBankName
},
{
label: this.$t("银行账号"),
value: invoice.purchaserBankAccount
},
{
label: this.$t("电话"),
value: invoice.purchaserTel
},
{
label: this.$t("地址"),
value: invoice.purchaserAddress
}
];
$self.invoiceInfo.sellerName = invoice.sellerName;
$self.invoiceInfo.sellerFormDetail = [
{
label: this.$t("名称"),
value: invoice.sellerName
},
{
label: this.$t("税号"),
value: invoice.sellerTaxNo
},

{
label: this.$t("开户行"),
value: invoice.sellerBankName
},
{
label: this.$t("银行账号"),
value: invoice.sellerBankAccount
},
{
label: this.$t("电话"),
value: invoice.sellerTel
},
{
label: this.$t("地址"),
value: invoice.sellerAddress
}
];
$self.invoiceInfo.invoiceDetailInfo = [
{
label: this.$t("发票日期"),
value: invoice.paperDrewDate
},
{
label: this.$t("发票号码"),
value: invoice.invoiceNo
},
{
label: this.$t("发票代码"),
value: invoice.invoiceCode
},
{
label: "",
value:
"<span class='text-warning'>" +
this.$t("该发票已通过国税局验真") +
"</span>"
}
];
}
});
},

shareToEmail() {
var $self = this;
$self.$vux.confirm.prompt(this.$t("请输入收票邮箱"), {
title: this.$t("发到邮箱"),
confirmText: this.$t("确定"),
cancelText: this.$t("取消"),
inputAttrs: {
type: "email"
},
onShow() {


},
onCancel() {},
onConfirm(newVal) {
if (!newVal || !regexpValid.email(newVal)) {
$self.$vux.toast.show({
text: $self.$t("请填写正确的邮箱"),
type: "text"
});
return;
}
let title = "电子发票";
let text =
"<div style='width:60%; height:auto; margin:0px auto;'>" +
"<p style='font-size:12px; color:#000'>尊敬的用户：<br>【请下载附件，查收您的电子发票】</p>" +
"<p style='font-size:12px; color:#333'>1、您可以直接使用电子发票作为 报销/售后服务 的依据。如需纸质版，请用A4纸彩色/黑白打印电子发票。</p>" +
"<p style='font-size:12px; color:#333'>2、根据《中华人民共和国发票管理办法》、国家税务总局公告2016年第23号、国家税务总局公告2017年第16号等税收法规的相关要求，不得虚开发票，发票内容应按照实际销售情况如实开具，不得根据购买方要求填开与实际交易不符的内容；商品折扣、优惠券需等要分摊，预付卡消费、代售服务类、租赁商品等需要扣除，以扣减分摊后的净额开具电子发票。</p>" +
"<p style='font-size:12px; color:#000'>感谢您支持绿色环保理念，助力国家税制改革。</p>" +
" <p>&nbsp;</p>" +
"<p style='font-size:12px; color:#333'>【电子发票小知识】</p>" +
"<p style='font-size:12px; color:#333'>问：电子发票可否用于报销？</p>" +
"<p style='font-size:12px; color:#333'>答：可以用于报销。根据《关于推行通过增值税电子发票系统开具的增值税电子普通发票有关问题的公告》（国家税务总局公告2015年第84号），正式规定打印版式电子发票的法律效力、基本用途和基本使用规定等于税务机关监制的增值税普通发票相同。</p>" +
"<p style='font-size:12px; color:#333'>&nbsp;</p>" +
"<p style='font-size:12px; color:#333'>问：电子发票是否可以享受售后服务？</p>" +
"<p style='font-size:12px; color:#333'>答：电子发票与纸质发票具有相同的法律效力，可作为售后、维权凭据。用户可凭电子发票要求商家和厂家进行维修。</p>" +
"<p style='font-size:12px; color:#333'>&nbsp;</p>" +
"<p style='font-size:12px; color:#333'>问：电子发票是否需要打印？</p>" +
"<p style='font-size:12px; color:#333'>答：2016年初，财务部、国家档案局联合公布的《会计档案管理办法》中已明确了电子会计档案的法律地位，只要满足该办法规定的条件，电子发票的开票方或受票方，可仅以电子形式对发票进行归档保存。开票方或受票方需要纸质发票的，可以自行打印增值税电子普通发票的版式文件。</p>" +
"<p style='font-size:12px; color:#333'>&nbsp;</p>" +
"<p style='font-size:12px; color:#333'>问：打印的黑白色电子发票是否有效？</p>" +
"<p style='font-size:12px; color:#333'>答：开票人和受票人可以自选纸张打印（彩色、黑白均可）电子发票的版式文件，其法律效力、基本用途、基本使用规定等与税务机关监制的增值税普通发票相同。</p>" +
"<p style='font-size:12px'>&nbsp;</p>";
if (newVal) {
var params = {
appKey: $self.appKey,
mailInfoData: {
attachments: [$self.invoiceInfo.pdfAddr],
to: [
{
address: newVal
}
],
subject: title,
text: text
}
};
$self.$clog("发送到" + newVal);
$self.sendInvoiceEmail(params).then(res => {
$self.$clog(res.data);
if (res.data.header.code == 0) {
$self.$vux.toast.show({
text: $self.$t("邮件发送成功"),
type: "text"
});
} else {
$self.$vux.toast.show({
text: $self.$t("邮件发送失败，请稍后重试"),
type: "text"
});
}
});
}
}
});
},

linkToPicture() {
var $self = this;
$self.$refs.imageSlidePreviewer.show(0);
return false;
},
sendInvoiceEmail(params) {
var $self = this;
return $self.getHttp2().post("/api/feedback/doMailSend", params);
},
getHttp2() {
/**
* http配置,后端要求body里数据以json格式传送，且参数不能序列号
*/
var instance = axios.create({
baseURL: conf.api.api_owt,
timeout: 60000,
headers: {
"Content-Type": "application/json;"
}
});


instance.interceptors.request.use(
config => {

if (config.method === "post") {

}
return config;
},
error => {
return Promise.reject(error);
}
);


instance.interceptors.response.use(
response => {

return response;
},
error => {

return Promise.reject(error);
}
);
return instance;
}
}
};
